import React, { useState } from 'react';

import { Flex, Text } from '@atlaskit/primitives/compiled';

import { Checkbox } from '@atlaskit/checkbox';
import type { ApplicationEdition } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useLegalNotice } from './useLegalNotice.tsx';

export interface LegalNoticeProps {
	onRenderLegalText?: (legalText: string) => void;
}

export const LegalNotice = ({
	hasPaymentDetails = false,
	onChange,
	edition = 'PREMIUM_EDITION',
	shouldUpgrade = true,
}: {
	hasPaymentDetails?: boolean | null;
	onChange?: (value: boolean) => void;
	edition?: ApplicationEdition;
	shouldUpgrade: boolean;
}): React.JSX.Element | null => {
	const [isChecked, setIsChecked] = useState(false);
	const message = useLegalNotice({
		edition,
		hasPaymentDetails: hasPaymentDetails || false,
	});

	const handleChange = () => {
		setIsChecked(!isChecked);
		onChange?.(!isChecked);
	};

	if (!edition) {
		return null;
	}

	if (edition === 'FREE_EDITION' || edition === 'UNLICENSED') {
		return null;
	}

	if (!shouldUpgrade) {
		return null;
	}

	if (hasPaymentDetails) {
		return (
			<Flex gap="space.050" justifyContent="start">
				<Checkbox
					onChange={handleChange}
					isChecked={isChecked}
					id="legal-consent-checkbox"
					aria-labelledby="legal-text"
				/>
				<Text id="legal-text" color="color.text.subtle" size="small">
					{message?.trialInfo} {message?.hasPaymentDetailsLegalText}
				</Text>
			</Flex>
		);
	}

	return (
		<Text color="color.text.subtle" size="small">
			{message?.trialInfo} {message?.hasPaymentDetailsLegalText}
		</Text>
	);
};
